// src/pages/approval/IncomeDraftNew.jsx
import React, { useEffect } from "react";
import DraftDocumentNew from "../draft_document/DraftDocumentNew";

export default function IncomeDraftNew() {
  useEffect(() => {
    document.title = "수입기안 작성";
  }, []);

  return <DraftDocumentNew fixedDocumentType="income_draft" />;
}
